import axios from 'axios'
import Qs from 'qs'
// import store from "@/stores/store";
import commonFn, { useMsToast } from '@/commons/commonFunction'
import i18n from '@/i18ns/i18n'
import moment from 'moment'
import { showError } from '@/commons/globalMessage'
import store from '@/stores/store'
import { ModuleContext } from '@/stores/moduleConst'
import LogUtil from '@/commons/logUtil'

// Danh sách đối tượng cần xử lý cancel request
let cancelRequests = []

/**
 * Lớp này dùng để thao tác với restful
 */
class AxiosHttpClient {
  /**
   * @param config: AxiosRequestConfig
   * @param isShowLoading: có cho loading hay không, hiển thị loading cho người dùng
   * @param isCancelRequest: có cho phép hủy request cùng url và method hay không
   * @param contentType: application/json, application/x-www-form-urlencoded, multipart/form-data
   */
  async postAsync (
    config,
    isShowLoading = false,
    isCancelRequest = true,
    contentType = ApplicationJson
  ) {
    return await this.requestAsync(
      config,
      POST,
      isShowLoading,
      isCancelRequest,
      contentType
    )
  }

  /**
   * @param config: AxiosRequestConfig
   * @param isShowLoading: có cho loading hay không, hiển thị loading cho người dùng
   * @param isCancelRequest: có cho phép hủy request cùng url và method hay không
   * @param contentType: application/json, application/x-www-form-urlencoded, multipart/form-data
   */
  async putAsync (
    config,
    isShowLoading = false,
    isCancelRequest = true,
    contentType = ApplicationJson
  ) {
    return await this.requestAsync(
      config,
      PUT,
      isShowLoading,
      isCancelRequest,
      contentType
    )
  }

  /**
   * @param config: AxiosRequestConfig
   * @param isShowLoading: có cho loading hay không, hiển thị loading cho người dùng
   * @param isCancelRequest: có cho phép hủy request cùng url và method hay không
   * @param contentType: application/json, application/x-www-form-urlencoded, multipart/form-data
   */
  async deleteAsync (
    config,
    isShowLoading = false,
    isCancelRequest = true,
    contentType = ApplicationJson
  ) {
    return await this.requestAsync(
      config,
      DELETE,
      isShowLoading,
      isCancelRequest,
      contentType
    )
  }

  /**
   * @param config: AxiosRequestConfig
   * @param isShowLoading: có cho loading hay không, hiển thị loading cho người dùng
   * @param isCancelRequest: có cho phép hủy request cùng url và method hay không
   * @param contentType: application/json, application/x-www-form-urlencoded, multipart/form-data
   */
  async getAsync (
    config,
    isShowLoading = false,
    isCancelRequest = true,
    contentType = ApplicationJson
  ) {
    return await this.requestAsync(
      config,
      GET,
      isShowLoading,
      isCancelRequest,
      contentType
    )
  }

  /**
   * @param config: AxiosRequestConfig
   * @param method: POST, PUT, GET, DELTE
   * @param isShowLoading: có cho loading hay không, hiển thị loading cho người dùng
   * @param isCancelRequest: có cho phép hủy request cùng url và method hay không
   * @param contentType: application/json, application/x-www-form-urlencoded, multipart/form-data
   */
  async requestAsync (
    config,
    method,
    isShowLoading = false,
    isCancelRequest = true,
    contentType = ApplicationJson
  ) {
    try {
      LogUtil.infoLogging(`requestAsync::url::${config.url}`)

      // Cập nhật các tham số của headers
      this._processHeaders(config)

      // Cập nhật data
      this._processDataOrParams(config, method, contentType)

      // Hiển thị loading
      this._setLoading(isShowLoading, true)

      // Thực hiện gọi service
      const result = await axios(config)

      // Ẩn loading
      this._setLoading(isShowLoading, false)

      // Trả kết quả xử lý thành công
      if (result) {
        // xử lý kết quả trước khi return
        commonFn.processServerResponseData(result.data)

        return result.data
      }

      // Trường hợp request bị hủy nên trả về empty dữ liệu
      return {
        Success: false,
        Data: null,
        Code: 0,
        Message: i18n.t('i18nCommon.CancelRequest'),
        MessageDev: '',
      }
    } catch (ex) {
      const error = ex
      const statusCode = error.response.status

      // Log lỗi
      LogUtil.errorLogging('requestAsync::error::', error.response)
      switch (statusCode) {
        case HttpStatusCode.Unauthorized:
          showError(i18n.global.t('i18nMessage.Unauthorized')).then(() => {
            commonFn.logoff()
          })
          break
        case HttpStatusCode.InternalServerError:
          useMsToast()?.error(i18n.global.t('i18nMessage.InternalServerError'))
          break
      }

      // Ẩn loading
      this._setLoading(isShowLoading, false)

      throw ex
    }
  }

  /**
   * config: AxiosRequestConfig
   * Chi tiết các thông tin trong config
   */
  _processDataOrParams (config, method, contentType = ApplicationJson) {
    if (!config) return

    // Xử lý method
    config.method = method

    switch (method) {
      case GET:
        // case DELETE:
        if (config.data) {
          const queryString = Qs.stringify(config.data || {})
          if (queryString) {
            config.url = [config.url, queryString].join(
              config.url.indexOf('?') === -1 ? '?' : '&'
            )
          }
        }
        break
      case POST:
      case PUT:
      case DELETE:
        if (contentType === FormUrlEncoded) {
          config.data = Qs.stringify(config.data || {})
        }

        if (config.data) {
          // xử lý date - loại bỏ múi giờ trước khi submit
          this.processSubmitData(config.data)
        }
        break
    }
  }

  /**
   * Xử lý date - loại bỏ múi giờ trước khi submit
   */
  processSubmitData (data, count = 0) {
    // tránh overflow
    if (count > 20) {
      return
    }

    const me = this
    for (const i in data) {
      const value = data[i]
      if (value) {
        if (typeof value.getFullYear === 'function') {
          data[i] = moment(value).format('YYYY-MM-DDTHH:mm:ss')
        } else if (Array.isArray(value)) {
          value.forEach((item) => {
            me.processSubmitData(item, count + 1)
          })
        } else if (typeof value === 'object' && Object.keys(value).length > 0) {
          me.processSubmitData(value, count + 1)
        }
      }
    }
  }

  /**
   * config: AxiosRequestConfig
   * Chi tiết các thông tin trong config
   */
  _processHeaders (config, contentType = ApplicationJson) {
    if (!config) return

    // Lấy dữ liệu của headers
    const headers = config.headers || {}

    if (!headers.Authorization) {
      const context = store.state[ModuleContext]
      if (context && context.Token) {
        headers.Authorization = context.Token ? `Bearer ${context.Token}` : ''
      }
    }

    // Content type - không set nếu data là FormData, để browser tự set với boundary
    if (!(config.data instanceof FormData)) {
      headers['Content-Type'] = contentType
    }

    // Cập nhật lại header
    config.headers = headers

    // thiết lập timeout cho request
    // eslint-disable-next-line no-prototype-builtins
    if (!config.hasOwnProperty('timeout') && window._appConfig.axiosTimeout) {
      config.timeout = window._appConfig.axiosTimeout
    }
  }

  /**
   * Lấy key để cancel request theo config
   * @param config
   */
  _getKey (config) {
    if (!config) return ''
    return `${config.url}_${config.method}`
  }

  /**
   * Hàm này cho phép hủy request
   * @param cancelRequest
   */
  _removeRequest (cancelRequest, from) {
    try {
      if (!cancelRequest) return

      // Hủy request
      if (cancelRequest.Value) {
        cancelRequest.Value.cancel()
      }

      // Xóa giá trị trong danh sách chờ hủy
      cancelRequests = cancelRequests.filter((n) => {
        return n.Key !== cancelRequest.Key || n.Time !== cancelRequest.Time
      })
    } catch (ex) {
      LogUtil.errorLogging('_cancelRequest::error:', ex)
    }
  }

  /**
   * Thêm vào danh sách hủy request
   * @param config
   * @param key
   * @param isCancelRequest
   */
  _addCancelRequest (config, key, isCancelRequest) {
    const me = this
    try {
      // Lấy các request có key và cần hủy
      const requests = cancelRequests.filter(
        (n) => n.Key === key && n.IsCancelRequest
      )
      if (requests != null && requests.length > 0) {
        requests.forEach((request) => me._removeRequest(request, 'add'))
      }

      // cancel token
      const cancelTokenSource = axios.CancelToken.source()

      // Cập nhật vào config
      config.cancelToken = cancelTokenSource.token

      // Tạo yêu cầu hủy request
      const cancelRequest = {
        Key: key,
        Value: cancelTokenSource,
        Time: new Date().getTime(),
        IsCancelRequest: isCancelRequest,
      }

      // Thêm vào danh sách chờ hủy request
      cancelRequests.push(cancelRequest)

      // Trả về tham số cancel request
      return cancelRequest
    } catch (ex) {
      LogUtil.errorLogging('_addCancelRequest::error::', ex)
    }

    return null
  }

  /**
   * Hàm này dùng để update trạng thái loading trong global state
   * @param isShowLoading có cho loading hay không, hiển thị loading cho người dùng
   * @param isLoading
   */
  _setLoading (isShowLoading, isLoading) {
    if (isShowLoading) {
      if (isLoading) {
        commonFn.mask()
      } else {
        commonFn.unmask()
      }
    }
  }
}

// Instance của axios client
export default new AxiosHttpClient()

// Các method của http
export const POST = 'POST'
export const PUT = 'PUT'
export const DELETE = 'DELETE'
export const GET = 'GET'

// Content-type
export const ApplicationJson = 'application/json'
export const FormUrlEncoded = 'application/x-www-form-urlencoded'
export const FormMultiPart = 'multipart/form-data'

export const HttpStatusCode = Object.freeze({
  OK: 200,
  Created: 201,
  BadRequest: 400,
  Unauthorized: 401,
  NotFound: 404,
  InternalServerError: 500,
  ServerMaintain: 503,
  BusinessError: 550,
})

//  * {
//  * url?: string;
//  * method?: string;
//  * baseURL?: string;
//  * transformRequest?: AxiosTransformer | AxiosTransformer[];
//  * transformResponse?: AxiosTransformer | AxiosTransformer[];
//  * headers?: any;
//  * params?: any;
//  * paramsSerializer?: (params: any) => string;
//  * data?: any;
//  * timeout?: number;
//  * withCredentials?: boolean;
//  * adapter?: AxiosAdapter;
//  * auth?: AxiosBasicCredentials;
//  * responseType?: string;
//  * xsrfCookieName?: string;
//  * xsrfHeaderName?: string;
//  * onUploadProgress?: (progressEvent: any) => void;
//  * onDownloadProgress?: (progressEvent: any) => void;
//  * maxContentLength?: number;
//  * validateStatus?: (status: number) => boolean;
//  * maxRedirects?: number;
//  * httpAgent?: any;
//  * httpsAgent?: any;
//  * proxy?: AxiosProxyConfig | false;
//  * cancelToken?: CancelToken;
//  * }
